import * as Html from "../../util/Html.ts";
import * as imageRedim from "../../lib/redim/imageRedim.ts";
import {newMultiBarSimple} from "../../util/progressbarmulti.ts"
import ApiServer from "../../ApiServer.ts";
import * as modal from "../../util/modal.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as amplify from "../../util/amplify.ts";
import * as Medias from "../../server/Medias.ts";
import TPL from "../../widget/input-images.mustache";
import { pickFileFromDevice } from "../../lib/FileUtils.ts";

export {initDom}
Html.registerWidget('widget/form/input-images',{initDom})

ApiServer["custom.wallpublishphoto"] = async function(form :HTMLFormElement,success){
  var
    input = form.querySelector('[data-widget="widget/form/input-images"]') as HTMLInputElement,
    files = input.customFiles.concat([]), //the concat is important to duplicate the file array, because the reset will clear it
    description = form.description?form.description.value:undefined;

  if(files.length===0){
    modal.alert('multiupload.needfile');
    return;
  }

  amplify.publish("resetNewActivity");
  await uploadMultiplePictures(files, description);

}
export async function uploadMultiplePictures(files : File[], description ?:string) {
  if(files.length>50){
    await modal.alert({
      title:"files.warnupload.title",
      message:"files.warnupload.message",
    })
    files.length = 50
  }
  var
    wallMessageClientId = new Date().getTime(),
    progressController = newMultiBarSimple(files.length), maxdim = FwDatas.getPermission("photoHD") ? { width: 4096, height: 4096 } : { width: 2048, height: 2048 };

  try{
    for (let i = 0; i < files.length; i++) {
      var file = files[i];
      if (file.size > 1000000) {
        try{
          file = await imageRedim.downsize(file, maxdim) as File;
        }catch(e){
          console.log('downsize failed, keep full file',e)
        }

      }
      var isLast = i === files.length - 1;
      await ApiServer.wallpublishmultiplepics.setOptions({ progressbar: progressController.subProgress() })({
        wallMessageClientId: wallMessageClientId,
        description: description,
        picture: file,
        finishupload: isLast
      });
    }
  }finally{
    amplify.publish("newActivity");
    progressController.close();
  }
}

function initDom(node: HTMLElement){
  const accept = node.getAttribute("data-fw-accept") || "image/*";
  const previewContainer = node.querySelector('.fw-dz-add-preview-container>span') as HTMLElement;
  const form = node.closest('form') as HTMLFormElement;
  const files = (node as any).customFiles = [];

  form.addEventListener('paste', async function(event: ClipboardEvent){
    if(!await Medias.checkQuota()) return;
    const items = event.clipboardData?.items;
    if(!items) return;
    for(let i=0; i<items.length; i++){
      const item = items[i];
      const file = item.getAsFile();
      if(file) append(file);
    }
  });

  if((form as any).clipboardImages){
    (form as any).clipboardImages.forEach(append);
  }

  node.addEventListener("click", async function(e){
    const selectedFiles = await pickFileFromDevice(accept, true);
    if(!await Medias.checkQuota()) return;
    for(let i=0; i<selectedFiles.length; i++){
      append(selectedFiles[i]);
    }
  })
  

  async function append(file: File){
    if(!file) return;
    if(accept!=='*/*'){
      if(file.type.indexOf("video")===0 && accept.indexOf('video')===-1){
        Html.trigger(null,'takepremium')
        return;
      }
    }
    files.push(file);
    node.classList.toggle("fw-dz-hasfile", files.length!==0);

    let preview: HTMLElement;
    function remove(){
      const idx = files.indexOf(file);
      if(idx>-1){
        files.splice(idx,1);
      }
      preview.remove();
      node.classList.toggle("fw-dz-hasfile", files.length!==0);
    }

    if(previewContainer){
      preview = Html.setHtmlAtEndDom(previewContainer, TPL, file);
      try{
        const rect = preview.getBoundingClientRect();
        const thumb = await imageRedim.thumbnail(file, {width:rect.width, height:rect.height});
        const img = preview.querySelector("img") as HTMLImageElement;
        if(img) img.src = thumb;
      }catch(e){
        remove()
      }

      preview.addEventListener("click", function(evt){
        evt.stopPropagation();
      });

      const icon = preview.querySelector("icon");
      if(icon) {
        icon.addEventListener("click", function(evt){
          evt.stopPropagation();
          remove();
        });
      }
    }
  }

}

